<template>
  <div class="wc-rotate-overlay" role="alert" :data-message="$t('rotateDeviceMessage')">
    <div class="wc-rotate-overlay__badge">
      <font-awesome-icon icon="mobile-screen-button" class="wc-rotate-overlay__icon" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-rotate-overlay {
  display: none;
}

// Phones in landscape: a touch device whose landscape height stays under 30em
// (~480px). Tablets and desktop windows are taller, so they are unaffected.
@media only screen and (orientation: landscape) and (max-height: 30em) and (pointer: coarse) {
  .wc-rotate-overlay {
    display: grid;
    position: fixed;
    inset: 0;
    z-index: map-get($zindex, 'rotate-device-overlay');
    place-content: center;
    justify-items: center;
    gap: convert-px-to-rem(20);
    padding: convert-px-to-rem(24) convert-px-to-rem(48);
    text-align: center;
    background-color: var(--white, get-color('white'));

    &::after {
      content: attr(data-message);
      max-width: convert-px-to-rem(340);
      white-space: pre-line;
      font-size: convert-px-to-rem(17);
      font-weight: 500;
      line-height: 1.5;
      color: var(--dark-lighter-2, get-color('dark', 'lighter-2'));
    }
  }
}

.wc-rotate-overlay__badge {
  display: grid;
  place-items: center;
  width: convert-px-to-rem(96);
  height: convert-px-to-rem(96);
  border-radius: 50%;
  background-color: var(--primary-lighter-9, var(--primary));
}

.wc-rotate-overlay__icon {
  font-size: convert-px-to-rem(46);
  color: var(--primary);
  animation: wc-rotate-overlay-turn 2.4s ease-in-out infinite;
}

@keyframes wc-rotate-overlay-turn {
  0%,
  25% {
    transform: rotate(90deg);
  }

  55%,
  100% {
    transform: rotate(0deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .wc-rotate-overlay__icon {
    transform: rotate(0deg);
    animation: none;
  }
}
</style>
